import { CommonModule } from '@angular/common';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, inject, Input } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule],
  selector: 'invd-fm-progress-bar',
  templateUrl: './fm-progress-bar.component.html',
  styleUrls: ['./fm-progress-bar.component.scss'],
})
export class FmProgressBarComponent implements OnInit, OnChanges {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('steps') progressBarSteps: Array<object>;
  @Input() currentStep: string;
  @Input() isResponsive = true; //toggle false to handle own responsiveness
  @Input() ignoreRoute = false; // don't listen to route changes and disable links
  protected currentStepIndex: number;

  public steps: Array<any>;

  private router = inject(Router);

  findIndex(array, property, value) {
    let position = 0;
    for (const x in array) {
      if (Object.hasOwn(array, x)) {
        if (array[x][property] === value) {
          break;
        }
        position++;
      }
    }

    return position;
  }

  navigateLink(e) {
    if (e.currentTarget.className === 'disabled') {
      e.preventDefault();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentStep) {
      this.currentStepIndex = this.findIndex(this.steps, 'url', changes.currentStep.currentValue);
    }
  }

  ngOnInit() {
    this.buildProgressBarSteps();
    if (!this.ignoreRoute) {
      this.progressBarStepsOnChangeListener();
    }
  }

  private buildProgressBarSteps(): void {
    this.steps = this.copyArray(this.progressBarSteps);
  }

  private progressBarStepsOnChangeListener(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const newRoute = this.router.routerState.snapshot.url;
        const newRouteArray = this.router.routerState.snapshot.url.split('/');
        if (newRoute === this.steps[0].url) {
          setTimeout(() => {
            this.steps = this.copyArray(this.progressBarSteps);
          }, 750);
        } else if ('/' + newRouteArray[newRouteArray.length - 1] === this.steps[1].url) {
          this.steps.forEach(function (el: any, index) {
            if (index > 0) {
              if (index > 1) {
                const temp = newRoute + el.url;
                el.url = temp;
              } else {
                const temp = newRoute;
                el.url = temp;
              }
            }
          });
        }
        this.currentStep = newRoute;
        this.currentStepIndex = this.findIndex(this.steps, 'url', this.currentStep);
      }
    });
  }

  private copyArray(arr) {
    const newArr = [];
    arr.forEach(function (el, _index) {
      const newEl = Object.assign({}, el);
      newArr.push(newEl);
    });

    return newArr;
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
